'use strict';

angular.module('supervisorAccessReviewControllers')

.controller('ActionsOnCardSysRoleEmployeeController', ['$scope', function ($scope) {

    $scope.displayActions = false;

    $scope.showOrHideActions = function () {
        if ($scope.isSubmitted()) $scope.displayActions = false;
        else $scope.displayActions = !$scope.displayActions;
    }

    $scope.removeRight = function () {
        $scope.sysRoleToReview.ToRemoveRight = true;
    }

    $scope.reAddRight = function () {
        $scope.sysRoleToReview.ToRemoveRight = false;
    }

    $scope.isRemoveRight = function () {
        return $scope.sysRoleToReview.ToRemoveRight;
    }

    $scope.isConfirmedRight = function () {
        var toRemoveRight = $scope.sysRoleToReview.ToRemoveRight;

        return !_.isUndefined(toRemoveRight) && toRemoveRight === false;
    }

    $scope.isSubmitted = function () {
        return $scope.sysRoleToReview.IsSubmitted;
    }
}]);